<template>
  <div class="promotion-box">
    <!--操作栏-->
    <div class="action-bar">
      <div class="action-left">
        <el-input placeholder="请输入用户id" size="small" class="param-input" v-model="params.uid"></el-input>
        层级查询:
        <el-select v-model="params.type" placeholder="层级查询" size="small" @change="getUserExtensionList('status')">
          <el-option v-for="item in hierarchy" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="getUserExtensionList()">搜索</el-button>
        <span style="margin-left: 35px;font-size:14px;color:#ccc">请通过输入用户id进行精准查询</span>
      </div>
      <div class="action-right">
        <span>一级总人数：<span>{{totalLv1}}</span></span>
        <span>二级总人数：<span>{{totalLv2}}</span></span>
        <span>三级总人数：<span>{{totalLv3}}</span></span>
        <span>四级总人数：<span>{{totalLv4}}</span></span> 
      </div>
    </div>
    <!--表格数据-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="uid" label="用户ID" align="center"></el-table-column>
      <el-table-column prop="iid" :label="params.type === 'up' ? '推广人ID' : '受邀人ID'" align="center"></el-table-column>
      <el-table-column prop="lv" label="层级" align="center"></el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import API from '@/api'
export default {
  data() {
    return {
      loading: false,
      total: 0,
      hierarchy: [{
        label: '上级',
        value: 'up'
      }, {
        label: '下级',
        value: 'down'
      }],
      tableData: [],
      // 一，二，三，四级人数
      totalLv1: 0,
      totalLv2: 0,
      totalLv3: 0,
      totalLv4: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        uid: '',
        type: 'up'
      }
    }
  },
  created() {
    this.getUserExtensionList()
  },
  methods: {
    // 请求用户推广查询列表
    getUserExtensionList(type) {
      if (type) {
        this.params.pageNumber = 1
      }
      this.loading = true
      API.getUserExtensionList(this.params).then(res => {
        if (res.code === 200) {
          if (JSON.stringify(res.data) !== '[]') {
            if (res.data.list) {
              this.tableData = res.data.list
              this.totalLv1 = res.data.totalLv1 || 0
              this.totalLv2 = res.data.totalLv2 || 0
              this.totalLv3 = res.data.totalLv3 || 0
              this.totalLv4 = res.data.totalLv4 || 0
            } else {
              this.tableData = []
              this.tableData.push(res.data[0])
            }
          } else {
            this.tableData = []
          }
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.tableData = []
        this.total = 0
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .action-bar {
    display: flex;
    .action-right {
      display: flex;
      margin-left: 70px;
      span {
        flex-grow: 1;
        margin-right: 35px;
        line-height: 33px;
      }
    }
  }
</style>
